import { Box, } from "@chakra-ui/react";
import { useQuery, } from "@tanstack/react-query";
import { limitPaymentCards, } from "../../../../api";
import { Toast, } from "../../../shared/Toast";

/**
 * Permanent notification about Denum Solutions contract termination.
 */
export function ContractTerminationNotice() {
  const paymentCards = useQuery(limitPaymentCards(),);

  if (!paymentCards.isSuccess || paymentCards.data.length === 0) {
    return null;
  }

  return (
    <Box role="status" aria-live="polite">
      <Toast
        iconPosition="right"
        message="Договор считается расторгнутым с 11.08.2026. Исполнение поручений с этого дня прекращается. График платежей действует без изменений. Спасибо, что вы с нами! Скоро вернемся к вам с новыми предложениями. ООО «Денум Солюшнз»."
      />
    </Box>
  );
}
